<template>
  <form @submit.prevent="saveContact()">
    <div
      v-if="!someoneEditing && !existing"
      class="btn-container"
    >
      <button
        class="btn btn-primary float-end add"
        type="button"
        @click="beginEdit()"
      >
        <font-awesome-icon :icon="['fas', 'pen']" />
        NEW
      </button>
    </div>
    <div v-else-if="existing || (editing && topOrBottom===currentTopOrBottom)">
      <!-- Visual indicator for prioritized / favorited contact (only shown after contact is saved) -->
      <div
        v-if="existing && !editing && localContact.primaryContact"
        class="contact-priority-banner mb-2 d-flex justify-content-between align-items-center"
      >
        <span class="badge bg-warning text-dark fs-6 p-2">
          <font-awesome-icon :icon="['fas', 'star']" /> Prioritized Primary Contact
        </span>
      </div>
      <h1
        v-if="immutable"
        class="mb-2"
      >
        {{ localContact.id }}
      </h1>
      <select
        v-else
        v-model="localContact.relationType"
        :disabled="!editing"
        class="col-12 fs-2 text-center mb-2"
      >
        <option
          v-for="relation in relationships"
          :key="relation.id"
          :value="relation.id"
        >
          {{ relation.value }}
        </option>
      </select>
      <div
        v-if="invitationStatus"
        class="invitation-status mb-2"
      >
        <span :class="'badge ' + getInvitationStatusClass(invitationStatus)">
          {{ invitationStatus }}
        </span>
      </div>
      <div
        v-if="editing && licensed"
        class="row mb-2 gx-2"
      >
        <div class="col-12 col-md-1 mb-2 mb-lg-0">
          <button
            :disabled="!enableFindButton"
            type="button"
            class="btn btn-primary"
            @click="queryContact"
          >
            {{ nurse ? "FIND A NURSE BY" : "LOOKUP BY" }}
          </button>
        </div>
        <div class="col-12 col-md-2 mb-2 mb-lg-0 form-floating">
          <input
            :id="id('queryLicense')"
            v-model.trim="locals.query.license.license"
            :disabled="!editing"
            type="text"
            class="form-control"
            placeholder="license"
          >
          <label
            :for="id('queryLicense')"
            class="profile_label"
          >LICENSE</label>
        </div>
        <div class="col-12 col-md-1 form-floating">
          <select
            :id="id('queryState')"
            v-model.number="locals.query.license.state"
            :disabled="!editing"
            class="form-control"
          >
            <option
              default
              value="0"
            >
              Select one
            </option>
            <option
              v-for="state in states"
              :key="state.id"
              :value="state.id"
            >
              {{ state.abbr }}
            </option>
          </select>
          <label
            :for="id('queryState')"
            class="profile_label"
          >STATE</label>
        </div>
        <div class="col-12 col-md-1 offset-md-1 ">
          <div class="row h-100 ps-0 pe-0 gx-0">
            <div class="col h-100">
              <div class="d-flex h-100 justify-content-center">
                <h4 class="align-self-center">
                  OR
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3 mb-2 mb-lg-0 form-floating">
          <input
            :id="id('queryFirst')"
            v-model.trim="locals.query.name.first"
            :disabled="!editing"
            type="text"
            class="form-control"
            placeholder="first name"
          >
          <label
            :for="id('queryFirst')"
            class="profile_label"
          >FIRST</label>
        </div>
        <div class="col-12 col-md-3 form-floating">
          <input
            :id="id('queryLast')"
            v-model.trim="locals.query.name.last"
            :disabled="!editing"
            type="text"
            class="form-control"
            placeholder="last name"
          >
          <label
            :for="id('queryLast')"
            class="profile_label"
          >LAST</label>
        </div>
      </div>
      <div v-if="editing && licensed">
        ADD A NEW NURSE
      </div>
      <div v-if="searchResults && searchResults.length === 0">
        No results
      </div>
      <div :class="'row xyz overflow-auto ' + (searchResults ? 'vh-100' : 'h-0')">
        <div
          v-for="(result,resultIndex) in searchResults"
          :key="result.id + (result.chosen ? 'x' : 'y')"
          :class="'xyz2 row mb-2 gx-2 h-auto ' + (result.chosen ? 'bg-primary text-white' : ((resultIndex%2)?'':'tint' ))"
          @click="clickResult(result)"
        >
          <div class="col-12 col-md-2 h-auto">
            <span>{{ (result.firstName || '') + ' ' + (result.lastName || '') }}</span>
          </div>
          <div class="col-12 col-md-1  h-auto">
            <span>{{ result.primaryPhone || '' }}</span>
          </div>
          <div class="col-12 col-md-1  h-auto">
            <span>{{ result.secondaryPhone || '' }}</span>
          </div>
          <!-- <div class="col-12 col-md-1">
            <span>{{ result.state ? states.find(s => s.id === result.state).abbr : '' }}</span>
          </div> -->
          <div class="col-12 col-md-1  h-auto">
            <span>{{ gg(result) }}</span>
          </div>
        </div>
      </div>
      <hr v-if="editing && nurse">
      <div class="row mb-2 gx-2">
        <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
          <input
            :id="id('firstName')"
            v-model="localContact.firstName"
            :disabled="!editing"
            type="text"
            class="form-control"
            placeholder="FIRST NAME"
          >
          <label
            :for="id('firstName')"
            class="profile_label"
          >FIRST NAME</label>
        </div>
        <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
          <input
            :id="id('lastName')"
            v-model="localContact.lastName"
            :disabled="!editing"
            type="text"
            class="form-control"
            placeholder="LAST NAME"
          >
          <label
            :for="id('lastName')"
            class="profile_label"
          >LAST NAME</label>
        </div>
        <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
          <input
            :id="id('primaryPhone')"
            v-model.trim="localContact.primaryPhone"
            :disabled="!editing"
            type="text"
            class="form-control"
            placeholder="PRIMARY PHONE"
          >
          <label
            :for="id('primaryPhone')"
            class="profile_label"
          >PRIMARY PHONE</label>
        </div>
        <div class="col-md-1 col-12 form-group form-floating mb-2 mb-lg-0">
          <select
            :id="id('primaryPhoneType')"
            v-model.number="localContact.primaryPhoneType"
            :disabled="!editing"
            class="col-12 form-select"
          >
            <option
              v-for="phone in phoneTypes"
              :key="phone.id"
              :value="phone.id"
            >
              {{ phone.type }}
            </option>
          </select>
          <label
            :for="id('primaryPhoneType')"
            class="profile_label"
          >PHONE TYPE</label>
        </div>
      </div>
      <div class="row mb-2 gx-2">
        <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
          <input
            :id="id('address1')"
            v-model="localContact.address1"
            :disabled="!editing"
            type="text"
            class="form-control"
            placeholder="ADDRESS 1"
          >
          <label
            :for="id('address1')"
            class="profile_label"
          >ADDRESS 1</label>
        </div>
        <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
          <input
            :id="id('address2')"
            v-model="localContact.address2"
            :disabled="!editing"
            type="text"
            class="form-control"
            placeholder="ADDRESS 2"
          >
          <label
            :for="id('address2')"
            class="profile_label"
          >ADDRESS 2</label>
        </div>
        <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
          <input
            :id="id('secondaryPhone')"
            v-model.trim="localContact.secondaryPhone"
            :disabled="!editing"
            type="text"
            class="form-control"
            placeholder="SECONDARY PHONE"
          >
          <label
            :for="id('secondaryPhone')"
            class="profile_label"
          >SECONDARY PHONE</label>
        </div>
        <div class="col-md-1 col-12 form-group form-floating mb-2 mb-lg-0">
          <select
            :id="id('secondaryPhoneType')"
            v-model="localContact.secondaryPhoneType"
            :disabled="!editing"
            class="col-12 form-select"
          >
            <option
              v-for="phone in phoneTypes"
              :key="phone.id"
              :value="phone.id"
            >
              {{ phone.type }}
            </option>
          </select>
          <label
            :for="id('secondaryPhoneType')"
            class="profile_label"
          >PHONE TYPE</label>
        </div>
      </div>
      <div class="row mb-2 gx-2">
        <div class="col-md-4 col-12 form-group form-floating">
          <input
            :id="id('email')"
            v-model.trim="localContact.email"
            :disabled="!editing"
            type="text"
            class="form-control"
            placeholder="EMAIL ADDRESS"
          >
          <label
            :for="id('email')"
            class="profile_label"
          >EMAIL ADDRESS</label>
        </div>
        <div class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0">
          <input
            :id="id('city')"
            v-model.trim="localContact.city"
            :disabled="!editing"
            type="text"
            class="form-control"
            placeholder="CITY"
          >
          <label
            :for="id('city')"
            class="profile_label"
          >CITY</label>
        </div>
        <div class="col-md-1 col-12 form-group form-floating mb-2 mb-lg-0">
          <select
            :id="id('state')"
            v-model.number="localContact.state"
            :disabled="!editing"
            type="text"
            class="form-select"
            placeholder="STATE"
          >
            <option
              v-for="state in states"
              :key="state.id"
              :value="state.id"
            >
              {{ state.abbr }}
            </option>
          </select>
          <label
            :for="id('state')"
            class="profile_label"
          >STATE</label>
        </div>
        <div class="col-md-1 col-12 form-group form-floating mb-2 mb-lg-0">
          <input
            :id="id('zip')"
            v-model.trim="localContact.zip"
            :disabled="!editing"
            type="text"
            class="form-control"
            placeholder="ZIP"
          >
          <label
            :for="id('zip')"
            class="profile_label"
          >ZIP</label>
        </div>
        <div
          v-if="immutable"
          class="col-md-2 col-12 form-group form-floating"
        >
          <select
            :id="id('relation')"
            v-model.number="localContact.relationType"
            :disabled="!editing"
            class="form-select"
          >
            <option
              v-for="relation in relationships"
              :key="relation.id"
              :value="relation.id"
            >
              {{ relation.value }}
            </option>
          </select>
          <label
            :for="id('relation')"
            class="profile_label"
          >RELATION</label>
        </div>
      </div>
      <!-- Prioritize contact checkbox when editing -->
      <div
        v-if="editing"
        class="row mb-2 gx-2"
      >
        <div class="col-12">
          <div class="form-check">
            <input
              :id="id('primaryContact')"
              v-model="localContact.primaryContact"
              type="checkbox"
              class="form-check-input"
            >
            <label
              class="form-check-label"
              :for="id('primaryContact')"
            >
              Prioritize this contact (Primary emergency contact)
            </label>
          </div>
        </div>
      </div>
      <div
        v-if="licensed"
        class="row mb-2 gx-2"
      >
        <div class="col-12 col-md-2 mb-2 mb-lg-0 form-floating">
          <input
            :id="id('license')"
            v-model.trim="localContact.license"
            :disabled="!editing"
            type="text"
            class="form-control"
            placeholder="license"
          >
          <label
            :for="id('license')"
            class="profile_label"
          >LICENSE</label>
        </div>
        <div class="col-12 col-md-1 form-floating">
          <select
            :id="id('licenseState')"
            v-model.number="localContact.licenseState"
            :disabled="!editing"
            class="form-control"
          >
            <option
              default
              value="0"
            >
              Select one
            </option>
            <option
              v-for="state in states"
              :key="state.id"
              :value="state.id"
            >
              {{ state.abbr }}
            </option>
          </select>
          <label
            :for="id('licenseState')"
            class="profile_label"
          >STATE</label>
        </div>
      </div>
      <div
        v-if="editing && verifiable"
        class="row mb-2 gx-2"
      >
        <div class="col-12 col-md-1 mb-2 mb-lg-0">
          <button
            :disabled="!enableVerifyButton"
            type="button"
            class="btn btn-primary"
            @click="verifyContact"
          >
            VERIFY
            LICENSE
          </button>
        </div>
        <div class="col-12 col-md-2 mb-2 mb-lg-0 form-floating">
          <input
            :id="id('verifyLicense')"
            v-model.trim="locals.verify.license"
            :disabled="!editing"
            type="text"
            class="form-control"
            placeholder="license"
          >
          <label
            :for="id('verifyLicense')"
            class="profile_label"
          >LICENSE</label>
        </div>
        <div class="col-12 col-md-1 form-floating">
          <select
            :id="id('verifyState')"
            v-model.number="locals.verify.state"
            :disabled="!editing"
            class="form-select"
          >
            <option
              disabled
              value="0"
            >
              Select one
            </option>
            <option
              v-for="state in states"
              :key="state.id"
              :value="state.id"
            >
              {{ state.abbr }}
            </option>
          </select>
          <label
            :for="id('verifyState')"
            class="profile_label"
          >STATE</label>
        </div>
        <div
          v-if="!existing && locals.verify.more"
          class="form-floating col-12 col-md-2 mb-2 form-floating"
        >
          <input
            :id="id('verifySsn')"
            v-model.trim="locals.verify.ssn"
            :disabled="!editing"
            type="text"
            :class="'form-control ' + (locals.verify.more ? 'border border-2 border-warning' : '')"
            placeholder="ssn"
          >
          <label
            :for="id('verifySsn')"
            class="profile_label"
          >SSN</label>
        </div>
        <div
          v-if="!existing && locals.verify.more"
          class="form-floating col-12 col-md-2 form-floating"
        >
          <input
            :id="id('verifyDob')"
            v-model.trim="locals.verify.dob"
            :disabled="!editing"
            type="date"
            :class="'form-control ' + (locals.verify.more ? 'border border-2 border-warning' : '')"
            placeholder="dob"
          >
          <label
            :for="id('verifyDob')"
            class="profile_label"
          >DOB</label>
        </div>
        <div
          v-if="!existing && locals.verify.more"
          class="align-self-center  col-md-4 col-12"
        >
          <span
            class="p-2 bg-warning text-body"
          >required</span>
        </div>
      </div>
      <div class="row mb-2">
        <div class="m-2 col text-black bg-warning">
          {{ locals.verify.message }}
        </div>
      </div>
      <div class="row mb-2">
        <div class="m-2 col">
          {{ licenseStatusDescription }}
        </div>
      </div>
      <div :class="((someoneEditing && !editing) ? 'invisible' : 'visible')">
        <div
          v-if="existing"
          class="btn-container"
        >
          <button
            v-if="!editing"
            type="button"
            class="btn btn-primary"
            @click="beginEdit()"
          >
            <font-awesome-icon :icon="['fas', 'pen']" /> EDIT
          </button>
          <button
            v-if="editing"
            type="reset"
            class="btn btn-primary "
            @click="cancelEdit()"
          >
            <font-awesome-icon :icon="['fas', 'pen']" /> CANCEL
          </button>
          <button
            v-if="dirty"
            type="submit"
            class="btn btn-primary"
          >
            <font-awesome-icon :icon="['fas', 'check']" /> SAVE
          </button>
          <button
            v-if="!immutable && editing"
            class="btn btn-primary float-end"
            type="button"
            @click="deleteContact()"
          >
            REMOVE FROM CURRENT CONTACTS
          </button>
          <!-- INVITE (Sep 2025) predates Contact registration; email flow still creates a
             Patient via VerifyContactPage, not a Contact with Contacts/Patients groups.
             Hidden until that path is rewired — use REGISTER instead. -->
          <!--
        <button v-if="canInvite" type="button" @click="inviteContact()" class="btn btn-success ms-2"
          :disabled="!localContact.email || invitationInProgress">
          <font-awesome-icon :icon="['fas', 'envelope']" />
          {{ invitationInProgress ? 'SENDING...' : 'INVITE' }}
        </button>
        -->
          <button
            v-if="canRegisterContact"
            type="button"
            class="btn btn-success ms-2"
            @click="openRegisterForm()"
          >
            <font-awesome-icon :icon="['fas', 'user-plus']" />
            REGISTER
          </button>
        </div>
        <div
          v-else
          class="btn-container"
        >
          <button
            v-if="dirty"
            type="submit"
            class="btn btn-primary"
            :disabled="verifiable && localContact.status !== 'UNENCUMBERED'"
          >
            <font-awesome-icon :icon="['fas', 'check']" /> SAVE
          </button>
          <button
            v-if="editing"
            class="btn btn-primary"
            @click="cancelEdit()"
          >
            <font-awesome-icon :icon="['fas', 'pen']" /> CANCEL
          </button>
        </div>
      </div>
      <div
        v-if="existing"
        class="btn-container"
      >
        <button
          v-if="localContact.primaryContact"
          type="button"
          class="btn btn-outline-danger float-end"
          @click="prioritizeContact(false)"
        >
          <font-awesome-icon :icon="['fas', 'ban']" /> REMOVE PRIORITY
        </button>
        <button
          v-if="!localContact.primaryContact"
          type="button"
          class="btn btn-primary float-end"
          @click="prioritizeContact(true)"
        >
          <font-awesome-icon :icon="['fas', 'star']" /> PRIORITIZE
        </button>
      </div>
    </div> <!-- endif -->
    <hr v-if="existing">
  </form>
</template>

<script>
import { getLicenses, getContacts, createContact, updateContact, deleteContact, renameContact, setPrimaryContact, isEmailExist } from "@/api/userApi";
import axios from 'axios';
import { CURR_API, OTHER_API } from "@/constants/apis";
import { classifyLookup, licenceForJurisdiction, lookupFailureMessage, FOUND, NOT_ENROLLED, UNAVAILABLE } from "@/api/nursysApi";
import { uuid } from 'vue-uuid';
import { PRIVILEGES } from "@/constants/privileges";
import { assertPrivilegeOrAlert } from "@/utils/privilegeGate";
import { provisionContactLogin, contactApiId, namedPatientId } from "@/api2/contactBridge";

/**
 * Main's family and emergency relations an INVITE was offered for ('Brother',
 * 'Daughter', 'Daughter in law', 'Emergency Contact', 'Father', 'Guardian',
 * 'Mother', 'Sister', 'Son', 'Son in law', 'Spouse'), in the port's
 * relationship ids (PatientContact::RELATIONSHIPS): matched by main's words,
 * only 'Spouse' was in the port's list, so the button would have been offered
 * almost never.
 */
const INVITABLE_RELATIONSHIPS = ['spouse', 'domestic_partner', 'parent', 'child', 'sibling', 'other_relative', 'health_care_proxy'];

export default {
  name: 'UserContact',
  props: {
    contact: { type: Object, required: true },
    allData: { type: Object, required: true },
    existing: { type: Boolean, required: true },
    someoneEditing: { type: Boolean, required: true },
    emptyContact: { type: Object, required: true },
    allContacts: { type: Array, required: true },
    topOrBottom: { type: String, required: true },
    currentTopOrBottom: { type: String, required: true }
  },
  data() {
    return {
      localContact: null,
      locals: this.emptyLocals(),
      editing: false,
      searchResults: null,
      invitationInProgress: false,
      invitationStatus: null
    }
  },
  computed: {
    dirty: function () {
      if (!this.editing)
        return false;
      let that = this;
      let result = Object.keys(this.contact)
        .some(
          k =>
            that.contact[k] !== that.localContact[k]
        );
      return result;
    },
    ltype() {
      return this.isRelated(['Licensed Practical Nurse']) ? 'LPN' : 'RN';
    },
    nurse() {
      return this.isRelated(['Licensed Practical Nurse', 'Registered Nurse']);
    },
    licenseStatusDescription: function () {
      if (this.localContact.status_time) {
        let status_time = typeof (this.localContact.status_time) === 'string' ?
          this.localContact.status_time :
          `(as of ${this.localContact.status_time.toLocaleString('en-US', { timeZone: 'America/New_York' })} EST)`;
        return this.localContact.status ?
          `${this.localContact.status} ${status_time}` :
          'Unverified'
      }
      else {
        return this.localContact.status || '';
      }
    },
    states: function () { return this.allData.states },
    phoneTypes: function () { return this.allData.phoneTypes },
    relationships: function () { return this.allData.relationDescriptions },
    immutable: function () {
      return false;
      /*
      return [
        'Emergency', 'Healthcare Proxy 1', 'Healthcare Proxy 2', 'Attorney',
        'maddress', 'paddress', 'personal', 'profile'].includes(this.localContact.id);
        */
    },
    verifiable: function () { 
      return this.isRelated([
        'Licensed Practical Nurse','Registered Nurse']);
    },
    licensed() {
      return this.isRelated([
        'Licensed Practical Nurse', 'Registered Nurse', 'Geriatric Care Manager',
        'Physical Therapist', 'Occupational Therapist', 'Dietician',
        'Social Worker', 'Speech Therapist']);
    },
    enableVerifyButton() {
      let verify = this.locals.verify;
      if (verify.license && verify.state)
        if (verify.more) {
          if (verify.dob && verify.ssn)
            return true;
          else
            return false;
        }
        else
          return true;
      return false;
    },
    enableFindButton() {
      if (this.editing) {
        let { name, license } = this.locals.query;
        if (name.first && name.last)
          return true;
        if (license.license && license.state)
          return true;
      }
      return false;
    },
    canInvite() {
      // Only allow invitation for specific family/emergency contacts, with an
      // address to send it to, who have no login yet.
      return INVITABLE_RELATIONSHIPS.includes(this.localContact.relationType)
        && !!this.localContact.email
        && this.canRegisterContact;
    },
    // Already-registered contacts (e.g. created via Administration Add Contact) must not show REGISTER again.
    canRegisterContact() {
      if (!this.existing || !this.localContact) return false;
      const registeredId = this.localContact.registered_unique_id;
      return !(registeredId !== null && registeredId !== undefined && String(registeredId).trim() !== "");
    }
  },
  watch: {
    'locals.verify.state': {
      deep: false,
      handler() {
        this.locals.verify.more = false;
      }
    },
    'locals.verify.license': {
      deep: false,
      handler() {
        this.locals.verify.more = false;
      }
    },
    contact: {
      deep: true,
      handler(newValue) {
        this.localContact = this.dup(newValue);
      }
    },
    'locals.query.name': {
      deep: true,
      handler(name) {
        if (name.first || name.last) {
          this.locals.query.license.license = '';
          this.locals.query.license.state = 0;
        }
      }
    },
    'locals.query.license': {
      deep: true,
      handler(license) {
        if (license.license || license.state) {
          this.locals.query.name.first = '';
          this.locals.query.name.last = '';
        }
      }
    }
  },
  created() { this.revertContact(); },
  methods: {
    openRegisterForm() {
      this.$emit('register-contact', this.dup(this.localContact));
    },
    gg(result) {
      console.log(result);
      let st = result.state;
      console.log(st);
      if (st) {
        let x = this.states.find(s => {
          console.log(s);
          return s.id === st;
        });
        console.log(x);
        if(x && x.abbr)
          return x.abbr;
        else
          return '';
      }
      else
        return '';
    },
    dup: o => JSON.parse(JSON.stringify(o)),
    revertContact() { this.localContact = this.dup(this.contact) },
    send(eventName) { this.$emit(eventName, { contact: this.localContact, existing: this.existing, topOrBottom: this.topOrBottom }); },
    alertMessages(messages) { 
      if(Array.isArray(messages))
      {
        let newMessages = { ...messages };
        messages = newMessages;
      }
      alert([...new Set(Object.values(messages))].join("\n")); 
    },
    refreshContact() {
      let o = this.localContact;
      this.localContact = this.emptyContact;
      this.$nextTick(() => { this.localContact = o; })
    },
    beginEdit() {
      if (
        !assertPrivilegeOrAlert(
          PRIVILEGES.EDIT_PATIENT_CONTACT,
          "You do not have permission to edit patient contacts."
        )
      ) {
        return;
      }
      this.editing = true;
      this.searchResults = null;
      this.refreshContact();
      this.send('begin-edit');
    },
    cancelEdit() {
      this.locals.verify.message = '';
      this.editing = false;
      this.revertContact();
      this.refreshContact();
      this.locals = this.emptyLocals();
      this.searchResults = null
      if(!this.existing) {
        this.localContact.status = '';
        this.localContact.status_time = null;
      }
      this.send('cancel-edit');
    },
    deleteContact() {
      this.locals.verify.message = '';
      this.editing = false;
      this.send('delete-contact');
      this.send('load-model');
    },
    prioritizeContact(value) {
      const accountnumber = this.allData?.patient?.externId2 || this.allData?.patient?.externid2 || '';
      const patientUniqueId = String(this.allData?.patient?.externId || this.allData?.patient?.externid || this.allData?.patient?.psersonalID || this.allData?.patient?.id || '').trim();

      setPrimaryContact({
        id: this.localContact.id,
        contact_uuid: this.localContact.id,
        primaryContact: value,
        primary_contact: value,
        accountnumber,
        patient_unique_id: patientUniqueId,
        patientUniqueId,
      })
        .then(response => {
          if (!response || response.length === 0 || response.length === undefined || response.status === "Successful") {
            this.localContact.primaryContact = value;
            this.send('load-model');
          }
          else {
            this.alertMessages(response);
          }
        })
        .catch(err => {
          console.error("Failed to prioritize contact:", err);
          alert("Error updating priority contact status");
        });
    },
    saveContact() {
      let process = f => {
        let temp = this.dup(this.localContact);
        if(temp.id === undefined || !temp.id)
          temp.id = uuid.v4();

        // Attach patient scope to bind this contact to the specific patient/user
        const accountnumber = this.allData?.patient?.externId2 || this.allData?.patient?.externid2 || '';
        const patientUniqueId = String(this.allData?.patient?.externId || this.allData?.patient?.externid || this.allData?.patient?.psersonalID || this.allData?.patient?.id || '').trim();
        temp.accountnumber = accountnumber;
        temp.patient_unique_id = patientUniqueId;
        temp.patientUniqueId = patientUniqueId;
        temp.contact_uuid = temp.id;

        // Resolve relationship label and state abbreviations from reference lists
        if (temp.relationType && this.relationships) {
          const rel = this.relationships.find(r => r.id === temp.relationType);
          if (rel) temp.relationName = rel.value;
        }
        if (temp.state && this.states) {
          const st = this.states.find(s => s.id === temp.state);
          if (st) temp.stateAbbr = st.abbr;
        }
        if (temp.secondaryState && this.states) {
          const st = this.states.find(s => s.id === temp.secondaryState);
          if (st) temp.secondaryStateAbbr = st.abbr;
        }
        if (temp.licenseState && this.states) {
          const st = this.states.find(s => s.id === temp.licenseState);
          if (st) temp.licenseStateAbbr = st.abbr;
        }

        f(temp)
          .then(rawResponse => {
            if (rawResponse && (rawResponse.status === "Successful" || rawResponse.success === true)) {
              this.editing = false;
              this.searchResults = null;
              this.send('contact-saved');
              this.locals = this.emptyLocals();
              this.locals.verify.message = '';
              return;
            }
            let response;
            if(typeof(rawResponse) === 'object' && rawResponse !== null)
            {
              response = Object.values(rawResponse);
            }
            else
              response = rawResponse;
            if (response === null || response === undefined || !response.length) {
              this.editing = false;
              this.searchResults = null;
              this.send('contact-saved');
              this.locals = this.emptyLocals();
              this.locals.verify.message = '';
            }
            else {
              this.alertMessages(response);
            }
          })
          .catch((err) => {
            console.error("Save contact failed:", err);
            alert('Error: Please contact website administrator');
          });
      };
      let localContact = this.localContact;
      if(this.licensed)
      {
        for(let k in this.allContacts)
        {
          if(this.allContacts[k].id === localContact.id)
            continue;
          if(this.allContacts[k].license === localContact.license &&
            this.allContacts[k].licenseState === localContact.licenseState &&
            localContact.license && localContact.licenseState)
          {
            alert('Duplicate licensed individual');
            return;
          }
        }
      }
      else
      {
        for(let k in this.allContacts)
        {
          if(this.allContacts[k].id === localContact.id)
            continue;
          if(this.allContacts[k].email === localContact.email && localContact.email)
          {
            alert('Duplicate email');
            return;
          }
        }
      }
      if(!this.licensed)
      {
        this.localContact.license = '';
        this.localContact.licenseState = 0;
        this.localContact.licenseId = undefined;
      }
      process(this.existing ? updateContact : createContact);
    },
    emptyLocals() {
      return this.dup({
        query: {
          name: { first: '', last: '' },
          license: { license: '', state: 0 }
        },
        verify: { license: '', state: 0, dob: null, ssn: '', message: '', more: false }
      });
    },
    isRelated(items) {
      if (this.localContact.relationType && items.length) {
        let f = this.relationships.find(r => r.id === this.localContact.relationType);
        return f && items.includes(f.value);
      }
      return false;
    },
    id(token) {
      return !this.existing ?
        `new-${token}` :
        `${this.contact.id}-${token}`
    },
    applyFoundContact(contact) {
      for(let j in this.allContacts)
      {
        if(this.allContacts[j].license === contact.license && this.allContacts[j].licenseState === contact.licenseState &&
          contact.license && contact.licenseState)
          {
            alert('Duplicate licensed individual');
            return false;
          } 
      }
      for (let k of Object.keys(this.emptyContact)) {
        if (['relationType','id'].includes(k))
          continue;
        else if(k === 'license') {
          this.locals.verify.license = contact[k] || '';
        }
        else if(k === 'licenseState') {
          this.locals.verify.state = contact[k] || 0;
        }
        else
          this.localContact[k] = contact[k] || this.emptyContact[k];
      }
      this.refreshContact();
      return true;
    },
    queryContact() {
      let query = this.locals.query;
      let that = this;
      let localContact = this.localContact;
      for(let k in this.allContacts)
      {
        if(this.allContacts[k].id === localContact.id)
          continue;
        if(this.allContacts[k].license === query.license.license &&
          this.allContacts[k].licenseState === query.license.state &&
            localContact.license && localContact.licenseState)
          {
            alert('Duplicate licensed individual');
            return;
          }
      }
      getLicenses({
        ...query.name,
        ...query.license,
        ...query.state,
        state: this.stateCode(query.license.state)
      })
        .then(resp => {
          that.searchResults = resp;
        });
    },
    // The two-letter code of a state chosen from `states`: the entry's `abbr`.
    // Main's list bound a numeric id and carried the code beside it; the
    // port's ids are the codes. A value that is in no list ("Select one" is 0,
    // or a stale one) goes on as it is: the licence search reads 0 as no state
    // chosen and refuses one it cannot read, rather than searching without it.
    stateCode(state) {
      const chosen = (this.states || []).find(s => s.id === state);
      return chosen && chosen.abbr ? chosen.abbr : state;
    },
    clickResult(result) {
      if(!this.applyFoundContact(result))
        return;
      for (let searchResultIndex = 0; searchResultIndex < this.searchResults.length; searchResultIndex++) {
        this.searchResults[searchResultIndex].chosen;
        if (this.searchResults[searchResultIndex].id === result.id)
          this.searchResults[searchResultIndex].chosen = true;
        else
          this.searchResults[searchResultIndex].chosen = false;
      }
    },
    verifyContact() {
      let verify = this.locals.verify;
      let localContact = this.localContact;
      for(let k in this.allContacts)
      {
        if(this.allContacts[k].id === localContact.id)
          continue;
        if(this.allContacts[k].license === verify.license &&
          this.allContacts[k].licenseState === verify.state)
          {
            alert('Duplicate registered nurse');
            return;
          }
      }

      verify.message = "Verifying with Nursys...";
      let abbr = this.states.find(state => verify.state === state.id).abbr;
      // Returned so a caller can wait on it; the click handler ignores it.
      return this.startLookup({
        jurisdiction: abbr,
        rnlicense: verify.license
      })
        .then((res) => {
          // Which of keyon's three answer shapes this is. Testing for a
          // `msg` key treated an outage the same as a negative answer, and
          // the arm below goes on to post the contact's last four SSN digits
          // and birth year to NCSBN.
          const verdict = classifyLookup(res?.data);
          if (verdict.kind === UNAVAILABLE) {
            verify.message = 'We could not reach the license verification service just now. Nothing has been submitted. Please try again in a few minutes.';
            return;
          }
          if (this.existing) {
            if (verdict.kind !== FOUND) {
              verify.message = verdict.message || 'License status cannot be verified at this moment. Please contact system administration';
              return;
            }
            let stateData = licenceForJurisdiction(verdict.licences, abbr);
            if (!stateData) {
              verify.message = 'No license for that state was found. Please check the license number and state.';
              return;
            }
            let encumberStatus = stateData.LicenseStatus.toUpperCase();
            if (encumberStatus === 'UNENCUMBERED' || encumberStatus === 'ENCUMBERED' || encumberStatus === 'EXPIRED') {
              if(verify.license && verify.state)
              {
                localContact.license = verify.license;
                localContact.licenseState = verify.state
                // Main also wrote the status to pacmny-be's licence table
                // (updateLicenseStatus). A contact's licence is on its own row
                // in the port, and the status below is saved with it on Save
                // (license_status, display only); there is no licence record
                // of a contact's to address, so that write is not made.
              }

              this.localContact.status_time = new Date();
              this.localContact.status = encumberStatus;
              verify.message = 'Verification request complete'
            }
            else {
              verify.message = 'License status cannot be verified at this moment. Please contact system administration';
            }
            return;
          }
          if (!res.data.status) {
              let stateData2 = res.data.find(d=> d.JurisdictionAbbreviation == abbr);
            if (!stateData2) {
              verify.message = 'Cannot verify the state of the provided license ID';
              return;
            }
            let encumberStatus2 = stateData2.LicenseStatus.toUpperCase();
            if (encumberStatus2 === 'UNENCUMBERED' || encumberStatus2 === 'ENCUMBERED' || encumberStatus2 === 'EXPIRED') {
              localContact.status = encumberStatus2;
              localContact.status_time = new Date();
              if(verify.license && verify.state)
              {
                localContact.license = verify.license;
                localContact.licenseState = verify.state
              }
              verify.message = '';
            }
            else {
              alert('License status cannot be verified at this moment. Please contact system administration');
              localContact.status = '';
              localContact.status_time = new Date();
              this.verifyMessage = "License status cannot be verified at this moment. Please contact system administration";
            }
            return;
          }
          if (!verify.ssn || !verify.dob) {
            verify.more = true;
            verify.message = '';
            localContact.status = '';
            localContact.date = new Date();
            this.verifyMessage = "";
            return;
          }
          if (verdict.kind !== NOT_ENROLLED) {
            verify.message = verdict.message || 'That license could not be verified. Please check the license number and state.';
            return;
          }
          return this.startAdd({
            jurisdiction: abbr,
            state: abbr,
            licensnum: verify.license,
            bdayear: verify.dob.substring(0, 4),
            lastfourssn: verify.ssn
          })
          .then((res) => {
            if (res.data.status === "Nurse Added") {
              localContact.status = 'UNENCUMBERED';
              localContact.status_time = new Date();
              verify.message = "";
              verify.more = false;

              this.send('load-model');
              if(verify.license && verify.state)
              {
                this.$nextTick(() => {
                  localContact.license = verify.license;
                  localContact.licenseState = verify.state
                });
              }
             }
            else {
              verify.message = "Failed to verify nurse information. Please make sure all the requried fields are filled properly and try again.";
              localContact.status = '';
              localContact.status_time = new Date();
            }
          }, (error) => {
            // A refused enrolment is not her details being wrong.
            verify.message = lookupFailureMessage(error);
            localContact.status = '';
            localContact.status_time = new Date();
          });
        }, (error) => {
          // axios rejects a refused request - keyon's Nursys gate answers a
          // lapsed session with 401 - and with no arm here the form stayed on
          // "Verifying with Nursys..." and nothing was said.
          verify.message = lookupFailureMessage(error);
        });
    },
    async webHook(request) {
      return await axios.post(
        CURR_API + "/tswebhook.php",
//        "https://20.231.24.137/keyon/tswebhook.php",
        request,
        { headers: { 'Content-Type': 'application/json;' } });
    },
    async startLookup(request) {
      return this.webHook({
        NursyInfo: {
          API_Meth: "LookupNursesInfo", ncsid: "",
          ltype: this.ltype, ...request
        }
      });
    },
    // No fabricated address here. This used to file "Manhattan / New York /
    // 10001" and an invented practice setting with NCSBN under the contact's
    // own name; the caller passes what it actually knows.
    async startAdd(request) {
      return this.webHook({ManageNurseList:{
        API_Meth: "Add_Nurse", ncsid: "", subactioncode: "A",
        ltype: this.ltype, address1: "", address2: "",
        city: "", state: "", zip: "",
        hospitalpracsetting: "", hostpracsettingother: "",
        notficationenabled: "N", reminderenabled: "N",
        locationlist: "", recid: "", ...request
      }});
    },
    /**
     * INVITE gives this contact a login and has pacmny-auth mail the
     * invitation — the port's POST /patients/{patient}/contacts/{contact}/account
     * (ACC-19), the same request REGISTER makes once its form is saved. Main's
     * Account.SendContactInvitationEmail mailed a link with an empty token that
     * created a Patient, which is why main's template hides the button and
     * points at REGISTER (the comment above it); the button stays hidden here
     * as on main, and this is what it does if it is shown. The contact must be
     * saved first: an unsaved row has no id on the chart to give a login to.
     */
    async inviteContact() {
      if (!this.localContact.email) {
        alert('Please add an email address for this contact before sending an invitation.');
        return;
      }

      const patientId = namedPatientId(this.localContact);
      const contactId = contactApiId(this.localContact);

      if (patientId === null || contactId === null) {
        alert('Save this contact before sending an invitation.');
        return;
      }

      this.invitationInProgress = true;

      try {
        const answer = await provisionContactLogin(patientId, contactId);
        const account = (answer && answer.account) || {};
        const name = `${this.localContact.firstName} ${this.localContact.lastName}`.trim();

        alert(account.created === false
          ? `${name} already has a login; they can now open this chart with it.`
          : `Invitation sent successfully to ${name} at ${this.localContact.email}`);
        this.invitationStatus = 'Invited';
        if (account.user_id) this.localContact.registered_unique_id = String(account.user_id);
        this.send('contact-saved');
      } catch (error) {
        console.error('Error sending invitation:', error);
        alert((error && error.message) || 'An error occurred while sending the invitation. Please try again.');
      } finally {
        this.invitationInProgress = false;
      }
    },
    getInvitationStatusClass(status) {
      switch(status) {
        case 'Invited':
          return 'bg-warning text-dark';
        case 'Pending':
          return 'bg-info text-white';
        case 'Accepted':
          return 'bg-success text-white';
        case 'Expired':
          return 'bg-danger text-white';
        default:
          return 'bg-secondary text-white';
      }
    }
  }
}
</script>

<style scoped="true" lang="scss">
@import '~bootstrap/scss/bootstrap.scss';


$utilities: map-merge($utilities,
    ("width": map-merge(map-get($utilities, "width"),
        (values: map-merge(map-get(map-get($utilities, "width"), "values"),
            (10: 10%),
          ),
        ),
      ),
    ));

$utilities: map-merge($utilities,
    ("viewport-height": map-merge(map-get($utilities, "viewport-height"),
        (values: map-merge(map-get(map-get($utilities, "viewport-height"), "values"),
            (10: 10%,
              20: 20%,
              30: 30%,
              40: 40%),
          ),
        ),
      ),
    ));


/* Colors/fonts live in the stylebook (.eh-ds in brand-ds.scss). Layout stays here. */

.xyz {
  max-height: 10vh;
  transition: height 1s;
}

input,
select {
  font-size: 0.8rem;
}

.btn-container {
  margin-top: 1rem;

  .btn {
    font-size: 0.8rem;
    margin: 2px;
  }

  padding-bottom: 3rem;
}

// form.not-editing input {
//   disab
// }

/* Override global CSS that breaks Bootstrap grid */
.row {
  display: flex !important;
  flex-wrap: wrap !important;
}

.col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-6, .col-md-12 {
  flex: 0 0 auto !important;
}

.col-md-1 { width: 8.33333333% !important; }
.col-md-2 { width: 16.66666667% !important; }
.col-md-3 { width: 25% !important; }
.col-md-4 { width: 33.33333333% !important; }
.col-md-6 { width: 50% !important; }
.col-md-12 { width: 100% !important; }

@media (max-width: 767.98px) {
  .col-12 {
    width: 100% !important;
  }
}

/* Ensure buttons are visible */
.btn-container {
  display: block !important;
}

.btn-container .btn {
  display: inline-block !important;
  visibility: visible !important;
}</style>
